import RecordBase from './Base';
import { useTranslation } from 'react-i18next';

export default class ProductRecord extends RecordBase {
  static defaultAttributes = {
    ean: '',
    bin: '',
    description: '',
    amount: '',
    currency: '',
    quantity: '',
    unlimited: true,
    duration: '',
    pack_type: '',
    created_at: '',
    updated_at: '',
    name: '',
    is_sellable: true,
    pack_id: null,
    has_membership_fee: false,
    membership_amount: null,
  };

  static _attributeNames = null;

  static get attributeNames() {
    const { t } = useTranslation();
    const trAttr = (attr) => t(`products.attributes.${attr}`);
    if (!this._attributeNames) {
      this._attributeNames = {
        ean: trAttr('ean'),
        bin: trAttr('bin'),
        description: trAttr('description'),
        amount: trAttr('amount'),
        currency: trAttr('currency'),
        quantity: trAttr('quantity'),
        unlimited: trAttr('unlimited'),
        duration: trAttr('duration'),
        pack_type: trAttr('pack_type'),
        created_at: trAttr('created_at'),
        updated_at: trAttr('updated_at'),
        name: trAttr('name'),
        is_sellable: trAttr('is_sellable'),
        pack: trAttr('pack'),
        has_membership_fee: trAttr('has_membership_fee'),
        membership_amount: trAttr('membership_amount'),
      };
    }
    return this._attributeNames;
  }

  toParams(attrs = {}) {
    const {
      ean,
      bin,
      description,
      amount,
      currency,
      quantity,
      unlimited,
      duration,
      pack_type,
      created_at,
      updated_at,
      name,
      is_sellable,
      pack_id,
      has_membership_fee,
      membership_amount,
    } = this.toObject();

    return {
      data: {
        attributes: {
          ean,
          bin,
          description,
          amount,
          currency,
          quantity,
          unlimited,
          duration,
          pack_type,
          created_at,
          updated_at,
          name,
          is_sellable,
          pack_id,
          has_membership_fee,
          membership_amount,
          ...attrs,
        },
      },
    };
  }
}
